import { createUseStyles } from 'react-jss';

export const useStyles = createUseStyles(() => ({
    subtext: ({ vertical }) => ({
        fontWeight: vertical === 'home-contents-insurance' ? '700' : '400'
    }),
    splashWrapper: ({ vertical }) => ({
        display: 'flex',
        flexDirection: 'column',
        textAlign: vertical === 'home-contents-insurance' ? 'left' : 'center',
        alignItems: vertical === 'home-contents-insurance' ?  'flex-start' : 'center',
        width: '100%',
        marginTop: '4.5rem'
    }),
    splashHeaderWrapper: {
        marginBottom: '2rem'
    },
    splashHeader: {
        margin: '0 auto'
    },
    quoteButtonWrapper: ({ vertical }) => ({
        display: 'flex',
        flexDirection: 'column',
        alignItems: vertical === 'home-contents-insurance' ?  'flex-start' : 'center',
        width: '100%'
    }),
    prefillButtonWrapper: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '1rem',
        width: '100%',
        maxWidth: '60rem',
        paddingLeft: '0',
        paddingRight: '0',
        margin: '0',
        '@media (max-device-width: 500px)': {
            flexDirection: 'column-reverse',
            padding: '2.5rem 0',
            gap: '2.5rem'
        },
        '& button': {
            fontSize: '1.6rem'
        }
    },
    prefillButtonWrapperHidden: {
        extend: 'prefillButtonWrapper',
        flexDirection: 'column',
        maxWidth: '18rem',
        marginBottom: '1rem',
        marginTop: '1.5rem',
        '@media (max-device-width: 500px)': {
            padding: '0'
        },
    },
    linkText: {
        cursor: 'pointer',
        textDecoration: 'underline'
    }
}));
